<app-restricted-state [heading]="eProfileMessages.RESTRICTED_TITLE" [message]="eProfileMessages.RESTRICTED_BODY"></app-restricted-state>
